import React, {useContext} from 'react'
import {BarLineStyles} from './Style'
import {ReactComponent as MaleIcon} from 'assets/icons/Male.svg';
import {ReactComponent as FemaleIcon} from 'assets/icons/Female.svg';
import {ReactComponent as NewImmigrantIcon} from 'assets/icons/NewImmigrant.svg';
import {ReactComponent as IsraelIcon} from 'assets/icons/Israel.svg';
import {SvgIcon, Tooltip} from '@mui/material';
import {AssessmentResultsTrackingContext} from './AssessmentResultsTrackingContext';
import {ratingBgColors, ratingBgColors2, ratingListLabel} from 'keys/rating';
import {useSelector} from 'react-redux';
import RatingSegmentation from './RatingSegmentation'
import BlurredText from "../../../../components/BlurredText";

const BarLine = (props) => {
    const {
        profileType,
        layout,
        totalTestTakers,
        segmentation,
        appliedAssessmentFilters
    } = useContext(AssessmentResultsTrackingContext)
    const {brokenDisplay} = useSelector(state => state.general)

    const {
        rating_1, rating_2, rating_3, rating_4, rating_5,
        expected_percent,
        rating_dict,
        low_female_count, low_male_count,
        low_new_immigrants_count, low_veteran_immigrants_count,
        test_taker_execution_count, low_rating_count, showBarSummary = true,
        lcBreakdown
    } = props
    const expected_count_num = props.expected_count;
    const unexpected_count_num = (+test_taker_execution_count) - (+props.expected_count);

    const half_low_female_count = low_female_count / 2
    const half_low_male_count = low_male_count / 2

    const half_low_new_immigrant_count = low_new_immigrants_count / 2
    const half_low_immigrant_count = low_veteran_immigrants_count / 2

    const half_low_rating_count = low_rating_count / 2

    // מוסיפים את מעט נמוך חצי לטווח המצופה וחצי לטווח הנמוך
    const expectedCount = rating_1 + rating_2 + (rating_3 / 2)
    const unexpectedCount = rating_4 + rating_5 + (rating_3 / 2)
    let unexpected = (1 - expected_percent) * 100
    let expected = (expected_percent) * 100

    // כשאנו נמצאים במצב מבדקים מבודדים אנו סופרים כל מבדק שנעשה, בתצוגת סוללות אנחנו מציגים לפי כמות תלמידים שבוצעו
    let assessment_execution_count = test_taker_execution_count

    const rating1 = (rating_1 / assessment_execution_count) * 100
    const rating2 = (rating_2 / assessment_execution_count) * 100
    const rating3 = (rating_3 / assessment_execution_count) * 100
    const rating4 = (rating_4 / assessment_execution_count) * 100
    const rating5 = (rating_5 / assessment_execution_count) * 100

    const _rating1 = (rating_1 / totalTestTakers) * 100
    const _rating2 = (rating_2 / totalTestTakers) * 100
    const _rating3 = (rating_3 / totalTestTakers) * 100
    const _rating4 = (rating_4 / totalTestTakers) * 100
    const _rating5 = (rating_5 / totalTestTakers) * 100

    const isProfileLayout = layout?.id == 'rating'
    let ratingKey = ''
    let ratingItems = {
        'rating_1': {
            bg: ratingBgColors2[1]
        },
        'rating_2': {
            bg: ratingBgColors2[2]
        },
        'rating_3': {
            bg: ratingBgColors2[3]
        },
        'rating_4': {
            bg: ratingBgColors2[4]
        },
        'rating_5': {
            bg: ratingBgColors2[5]
        },
    }
    if (isProfileLayout) {
        if (_rating1) {
            ratingKey = 'rating_1'
            expected = _rating1
        } else if (_rating2) {
            ratingKey = 'rating_2'
            expected = _rating2
        } else if (_rating3) {
            ratingKey = 'rating_3'
            expected = _rating3
        } else if (_rating4) {
            ratingKey = 'rating_4'
            expected = _rating4
        } else if (_rating5) {
            ratingKey = 'rating_5'
            expected = _rating5
        }
        unexpected = 100 - expected
    }

    const unexpectedMale = (((rating_dict.rating_3?.male_count || 0) / 2) + (rating_dict.rating_4?.male_count || 0) + (rating_dict.rating_5?.male_count || 0)) / unexpectedCount * 100;
    const unexpectedFemale = (((rating_dict.rating_3?.female_count || 0) / 2) + (rating_dict.rating_4?.female_count || 0) + (rating_dict.rating_5?.female_count || 0)) / unexpectedCount * 100;
    const expectedMale = (((rating_dict.rating_3?.male_count || 0) / 2) + (rating_dict.rating_2?.male_count || 0) + (rating_dict.rating_1?.male_count || 0)) / expectedCount * 100;
    const expectedFemale = (((rating_dict.rating_3?.female_count || 0) / 2) + (rating_dict.rating_2?.female_count || 0) + (rating_dict.rating_1?.female_count || 0)) / expectedCount * 100;

    const unexpectedNewImmigrant = (((rating_dict.rating_3?.immigrant_count || 0) / 2) + (rating_dict.rating_4?.immigrant_count || 0) + (rating_dict.rating_5?.immigrant_count || 0)) / unexpectedCount * 100;
    const unexpectedImmigrant = (((rating_dict.rating_3?.israeli_count || 0) / 2) + (rating_dict.rating_4?.israeli_count || 0) + (rating_dict.rating_5?.israeli_count || 0)) / unexpectedCount * 100;
    const expectedNewImmigrant = (((rating_dict.rating_3?.immigrant_count || 0) / 2) + (rating_dict.rating_2?.immigrant_count || 0) + (rating_dict.rating_1?.immigrant_count || 0)) / expectedCount * 100;
    const expectedImmigrant = (((rating_dict.rating_3?.israeli_count || 0) / 2) + (rating_dict.rating_2?.israeli_count || 0) + (rating_dict.rating_1?.israeli_count || 0)) / expectedCount * 100;

    const segmentationData = {
        "gender": {
            male: {
                color: "#529BE2", label: "בנים",
                value: (expectedMale + unexpectedMale).toFixed()
            },
            female: {
                color: "#F786CA", label: "בנות",
                value: (expectedFemale + unexpectedFemale).toFixed(),
            }
        },
        "immigrants": {
            immigrant: {
                color: "#C384E1", label: "עולים",
                value: (expectedNewImmigrant + unexpectedNewImmigrant).toFixed(),
            },
            israel: {
                color: "#539CE4", label: "ישראלים",
                value: (expectedImmigrant + unexpectedImmigrant).toFixed(),
            }
        },
        "profiles": {
            rating1: {
                color: ratingBgColors[0], value: rating1, rating: ratingListLabel[0]
            },
            rating2: {
                color: ratingBgColors[1], value: rating2, rating: ratingListLabel[1]
            },
            rating3: {
                color: ratingBgColors[2], value: rating3, rating: ratingListLabel[2]
            },
            rating4: {
                color: ratingBgColors[3], value: rating4, rating: ratingListLabel[3]
            },
            rating5: {
                color: ratingBgColors[4], value: rating5, rating: ratingListLabel[4]
            }
        }
    }
    const studentsWord = "תלמידים"

    // טולטיפ פירוט מרכזי למידה: undefined = הנתונים עוד נטענים (בלי טולטיפ),
    // {} = נטען ואין תלמידי מרכזי למידה בבר הזה
    const getLcTooltipContent = (countField) => {
        if (!lcBreakdown) return ""
        const rows = Object.entries(lcBreakdown).filter(([, counts]) => counts[countField] > 0)
        if (!rows.length) return "אין תלמידים במרכזי למידה"
        return (
            <div>
                {rows.map(([lcName, counts]) =>
                    <div key={lcName}>{`${lcName}: ${counts[countField]} ${studentsWord}`}</div>
                )}
            </div>
        )
    }

    return (
        <BarLineStyles
            unexpected={unexpected}
            expected={expected}
            rating1={rating1}
            rating2={rating2}
            rating3={rating3}
            rating4={rating4}
            rating5={rating5}
            isProfileLayout={isProfileLayout}
            ratingItem={ratingItems[ratingKey]}
            segmentation={segmentation?.id}
        >
            <div className='wrap-bar'>
                {/* {segmentation?.id &&
                    <CustomTooltip
                        title={
                            <SegmentationDoughnut
                                name={name}
                                segmentations={segmentationData?.[segmentation?.id]} />
                        }>
                        <SvgIcon component={DoughnutIcon} color="black" inheritViewBox />
                    </CustomTooltip>} */}
                <div
                    className={`bar-line ${profileType == 'PROFILES' ? "profiles-view" : "basic-layout"} ${layout?.id == 'rating' && "profile-layout"}`}>
                    {(profileType == 'PROFILES' && !isProfileLayout) ?
                        <React.Fragment>
                            <RatingSegmentation ratingName={"rating_1"} rating={rating1} count={rating_1} lcBreakdown={lcBreakdown}/>
                            <RatingSegmentation ratingName={"rating_2"} rating={rating2} count={rating_2} lcBreakdown={lcBreakdown}/>
                            <RatingSegmentation ratingName={"rating_3"} rating={rating3} count={rating_3} lcBreakdown={lcBreakdown}/>
                            <RatingSegmentation ratingName={"rating_4"} rating={rating4} count={rating_4} lcBreakdown={lcBreakdown}/>
                            <RatingSegmentation ratingName={"rating_5"} rating={rating5} count={rating_5} lcBreakdown={lcBreakdown}/>
                        </React.Fragment>
                        :
                        <React.Fragment>
                            {!expected || !assessment_execution_count ||
                                <Tooltip title={getLcTooltipContent('expected_count')} placement="top" arrow>
                                <div className='bar-line-item expected-rating-line'>
                                    <span className='percent'>
                                        {expected ? `${expected.toFixed()}%` : "-"}
                                        {!isProfileLayout && expected_count_num != null &&
                                            <span className='count'> ({<BlurredText>{expected_count_num}</BlurredText>} {studentsWord})</span>
                                        }
                                    </span>
                                    {segmentation?.id == 'gender' &&
                                        <div className='segmentation'>
                                            <div style={{width: `${expectedFemale}%`}} className={`dashed female`}>
                                                {expectedFemale > 3 &&
                                                    <Tooltip title={`${expectedFemale.toFixed()}% תלמידות בנות`}>
                                                        <SvgIcon fontSize="small" component={FemaleIcon} color="black"
                                                                 inheritViewBox/>
                                                    </Tooltip>}
                                            </div>
                                            {expectedFemale && expectedMale ? <div className='divider'/> : ""}
                                            <div style={{width: `${expectedMale}%`}} className={`dashed male`}>
                                                {expectedMale > 3 &&
                                                    <Tooltip title={`${expectedMale.toFixed()}% תלמידים בנים`}>
                                                        <SvgIcon fontSize="small" component={MaleIcon} color="black"
                                                                 inheritViewBox/>
                                                    </Tooltip>}
                                            </div>
                                        </div>}
                                    {segmentation?.id == 'immigrants' &&
                                        <div className='segmentation'>
                                            <div style={{width: `${expectedNewImmigrant}%`}}
                                                 className={`dashed new-immigrant`}>
                                                {expectedNewImmigrant > 3 &&
                                                    <Tooltip title={`${expectedNewImmigrant.toFixed()}% עולים`}>
                                                        <SvgIcon fontSize="small" component={NewImmigrantIcon}
                                                                 color="black" inheritViewBox/>
                                                    </Tooltip>}
                                            </div>
                                            {expectedNewImmigrant && expectedImmigrant ?
                                                <div className='divider'/> : ""}
                                            <div style={{width: `${expectedImmigrant}%`}}
                                                 className={`dashed old-immigrant`}>
                                                {expectedImmigrant > 3 &&
                                                    <Tooltip title={`${expectedImmigrant.toFixed()}% ישראלים`}>
                                                        <SvgIcon fontSize="small" component={IsraelIcon} color="black"
                                                                 inheritViewBox/>
                                                    </Tooltip>}
                                            </div>
                                        </div>}
                                </div>
                                </Tooltip>
                            }
                            {!unexpected || !assessment_execution_count ||
                                <Tooltip title={getLcTooltipContent('unexpected_count')} placement="top" arrow>
                                <div className='bar-line-item unexpected-rating-line'>
                                    {layout?.id !== 'rating' && <span className='percent'>
                                        {unexpected ? `${unexpected.toFixed()}%` : "-"}
                                        {unexpected_count_num &&
                                            <span className='count'> ({<BlurredText>{unexpected_count_num}</BlurredText>} {studentsWord})</span>}
                                    </span>}
                                    {segmentation?.id == 'gender' &&
                                        <div className='segmentation'>
                                            <div style={{width: `${unexpectedFemale}%`}} className={`dashed female`}>
                                                {unexpectedFemale > 3 &&
                                                    <Tooltip title={`${unexpectedFemale.toFixed()}% תלמידות בנות`}>
                                                        <SvgIcon fontSize="small" component={FemaleIcon} color="black"
                                                                 inheritViewBox/>
                                                    </Tooltip>}
                                            </div>
                                            {unexpectedFemale && unexpectedMale ? <div className='divider'/> : ""}
                                            <div style={{width: `${unexpectedMale}%`}} className={`dashed male`}>
                                                {unexpectedMale > 3 &&
                                                    <Tooltip title={`${unexpectedMale.toFixed()}% תלמידים בנים`}>
                                                        <SvgIcon fontSize="small" component={MaleIcon} color="black"
                                                                 inheritViewBox/>
                                                    </Tooltip>}
                                            </div>
                                        </div>}
                                    {segmentation?.id == 'immigrants' &&
                                        <div className='segmentation'>
                                            <div style={{width: `${unexpectedNewImmigrant}%`}}
                                                 className={`dashed new-immigrant`}>
                                                {unexpectedNewImmigrant > 3 &&
                                                    <Tooltip title={`${unexpectedNewImmigrant.toFixed()}% עולים`}>
                                                        <SvgIcon fontSize="small" component={NewImmigrantIcon}
                                                                 color="black" inheritViewBox/>
                                                    </Tooltip>}
                                            </div>
                                            {unexpectedImmigrant && unexpectedNewImmigrant ?
                                                <div className='divider'/> : ""}
                                            <div style={{width: `${unexpectedImmigrant}%`}}
                                                 className={`dashed old-immigrant`}>
                                                {unexpectedImmigrant > 3 &&
                                                    <Tooltip title={`${unexpectedImmigrant.toFixed()}% ישראלים`}>
                                                        <SvgIcon fontSize="small" component={IsraelIcon} color="black"
                                                                 inheritViewBox/>
                                                    </Tooltip>}
                                            </div>
                                        </div>}
                                </div>
                                </Tooltip>
                            }
                        </React.Fragment>}
                </div>
            </div>
            <div className={"bar-summary"}>
                {`תוצאות של `}
                <span className={`${brokenDisplay && "blurred2"}`}>
                    {test_taker_execution_count}
                </span>
                {" תלמידים "}
            </div>
        </BarLineStyles>
    )
}

export default BarLine